import Head from "next/head";
import { useEffect, useState } from "react";
import Coupons from "../components/Coupons";
import Discounts from "../components/Discounts";
import Hero from "../components/Hero";
import Modal from "../components/Modal";
import SeoHead from "../components/SeoHead";

// Impact.com site verification — temporary, remove after account verification
const IMPACT_VERIFY = {
  '1001cupomdedescontos.com.br': '543901c1-7e3f-4dc2-983d-ee57434e421b',
  'codigosdescuentospromocionales.es': '4a752a9d-e658-44ee-bcbb-2ba9198fd935',
  'kortingscouponcodes.nl': '7d2d216e-5371-4498-a942-2d835729666d',
  'tipdeal.be': '18b690a7-0cf6-45da-b847-29aadae600d8',
  'tipdeal.nl': 'bf026f39-8748-4f66-b77c-cf34d5bd269e',
  'kortingscouponcodes.be': 'e7b9f03a-186d-4fb7-9a66-647a7dc85a6f',
  'reductioncodepromo.be': '3e2a535a-3744-4b6c-abae-b496056c6cd0',
  'valesdedescontos.pt': '265ea1b1-4c17-4c9e-b276-f23a17ffabb0',
  'mygeschenkgutscheine.de': '630f36d3-18be-485f-b98e-84626553ad7d',
  '1001promocodes.com': '0e36ed83-25b2-4203-b0ab-79ccbbf1c5ce',
  '1001buonisconto.it': 'ac2da340-f712-4ad0-ab82-ac78ef1e2807',
  'reductioncodepromo.fr': 'fe624b6a-4032-4914-aa12-f7ce82035bc2',
  '1001vouchercodes.co.uk': 'e2540e02-3cae-4775-ad94-1c02b1fdf48b',
  '1001couponcodes.ca': '2fbf6007-d6ad-45ed-bd78-2c1e80cde773',
  'mygeschenkgutscheine.ch': 'fd99b8e0-446b-4331-8efd-158f7477bb04',
  'mygeschenkgutscheine.at': '824cc0ae-b92b-416b-8415-3d7d9487b716',
  '1001couponcodes.co.nz': '6dfad5ae-01bf-42eb-9201-9d29efb4e824',
  'kuponation.com': 'a3bcbb04-dc38-4582-890c-8c7feb8bbdb1',
  '1001cuponesdedescuento.com.ar': 'ef5a54f2-4195-4324-8f64-5497f068c878',
  '1001cuponesdedescuento.cl': 'd1da3168-c7c7-4a42-bbaf-0fe5bd300763',
  '1001cuponesdedescuento.com.pe': 'dd0da197-e67d-41f4-a9ca-c13c13ad6bd4',
  '1001cuponesdedescuento.com.co': '75e91799-5d69-4cd1-ad21-acb3433bc519',
  '1001cuponesdedescuento.com.mx': '224cc0d9-bf9e-4453-9c89-34a531ac729c',
};

export default function HomePage({
  translation,
  offers,
  slides,
  advertisement,
  domain,
  countryCode,
}) {
  const [showModal, setShowModal] = useState(false);
  const [currentCard, setCurrentCard] = useState();

  const openModalFromHash = () => {
    if (typeof window === "undefined") return;
    if (!window.location.hash) return;

    const cid = window.location.hash.slice(1);
    // Try exact match first
    let card = offers?.filter((offer) => offer.offers[0].id == cid)[0]?.offers[0];
    if (!card && offers?.length) {
      // goid from ZeroPark may not match — use first available
      card = offers[0]?.offers[0];
    }
    if (card) {
      setCurrentCard(card);
      setShowModal(true);
    }
  };

  useEffect(() => {
    openModalFromHash();
    const t = setTimeout(openModalFromHash, 300);
    return () => clearTimeout(t);
  }, [translation, offers]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.addEventListener("hashchange", openModalFromHash);
    const onPageShow = (e) => { if (e.persisted) openModalFromHash(); };
    window.addEventListener("pageshow", onPageShow);
    return () => {
      window.removeEventListener("hashchange", openModalFromHash);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [translation, offers]);

  const canonical = `https://www.${domain}/`;
  const image = `https://www.${domain}/logos/logo-${countryCode}.png`;

  return (
    <>
      <SeoHead
        title={translation?.home_meta_title}
        description={translation?.home_meta_description}
        canonical={canonical}
        image={image}
        domain={domain}
      />
      {IMPACT_VERIFY[domain] && (
        <Head>
          <meta name="Impact-Site-Verification" content={IMPACT_VERIFY[domain]} />
        </Head>
      )}

      <Modal
        currentCard={currentCard}
        url={"/"}
        showModal={showModal}
        setShowModal={setShowModal}
        translation={translation}
        domain={domain}
        countryCode={countryCode}
      />

      <Coupons
        slides={slides}
        title={translation?.home_h1}
        subtitle={translation?.meta_h1a}
        domain={domain}
      />

      <Hero slides={advertisement} title={translation?.home_h2} domain={domain} />

      <Discounts topOffers={offers} translation={translation} domain={domain} isEventPage={true} onCodeClick={(card) => {
        setCurrentCard(card);
        setShowModal(true);
      }} />
    </>
  );
}
